import React from 'react';

class ErrorBoundary extends React.Component {
    state = {
        hasError: false
    };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    // `source`: name of the external feature rendered inside, if any
    componentDidCatch(error, info) {
        const { source } = this.props;
        if (source) {
            console.error(`[features] ${source} failed to render:`, error, info);
        } else {
            console.error('Lazy-load error:', error, info);
        }
    }

    // `inline`: a component embedded in a core screen, not a whole page: short message only
    render() {
        const { source, inline } = this.props;
        if (this.state.hasError && inline) {
            return (
                <div className="cla-feature-error">
                    {_('The feature %1 failed to render', source)}
                </div>
            );
        }
        if (this.state.hasError) {
            return (
                <div
                    style={{
                        paddingTop: 150,
                        margin: 'auto',
                        textAlign: 'center'
                    }}
                >
                    {source
                        ? _('The feature %1 failed to render', source)
                        : _('Something went wrong!')}
                    <div style={{ padding: 20 }}>
                        <button onClick={() => location.reload(true)}>
                            {_('Retry')}
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
